import * as React from "react";
export default function Loader() {
    return <div className="flex-grow-1 align-self-center d-flex flex-column justify-content-center align-items-center">
        <div className="loader" />
    </div>
}
